import CareerJourneyCards from './CareerJourneyCards';
const About = () => {
  return (
    <section id="about" className="py-20 text-black bg-brand-cream dark:text-white dark:bg-gray-800 is-visible">
      
            <CareerJourneyCards/>
        </section>
  );
};

export default About;
